
import type { Channels } from '@eureka/shared/login-sdk';
import { loginSDK } from '@eureka/shared/login-sdk';
import type { I18n } from 'vue-i18n';

export function useLoginSdk(i18n: I18n, channels:Channels = {}) {
    loginSDK.setChannels(channels)
    loginSDK.handleThirdPartyLoginErrors()

    const openLoginDialog = () => {
        loginSDK.open({
            withoutClose: true,
        }).then(async() => {
            window.location.reload();
        })
    }

    return {
        openLoginDialog,
    }
}
